import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';
import LoadingChart from '../CommonComponents/LoadingChart';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Box } from '../CommonComponents/OPL/Box/Box';

export default class RecommendedTargetAmountChart extends Component {
  constructor(props) {
    super(props);
    this.load = this.load.bind(this);
  }

  load({ goalId, fpId, clientId, fetchData, receiveData, data }, showLoading) {
    if (data) {
      receiveData(
        {
          GoalChart: {
            Chart: data.GoalCharts[0],
            ...data,
          },
        },
        clientId,
      );
    } else {
      fetchData(goalId, fpId, clientId, showLoading);
    }
  }

  UNSAFE_componentWillMount() {
    this.load(this.props, true);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (
      newProps.fpId != this.props.fpId ||
      newProps.clientId != this.props.clientId ||
      newProps.goalId != this.props.goalId ||
      newProps.data != this.props.data
    ) {
      this.load(newProps, true);
    }
  }

  shouldComponentUpdate(newProps) {
    if (
      newProps.fpId == this.props.fpId &&
      newProps.clientId == this.props.clientId &&
      newProps.goalId == this.props.goalId
    ) {
      if (!ADV.util.shallowEqual(newProps.chartData, this.props.chartData)) {
        return true;
      }
      if (newProps.showLoading !== this.props.showLoading) {
        return true;
      }
      return false;
    }
    return true;
  }

  render() {
    const {
      chartData,
      noContainer,
      loading,
      isCurrentPlan,
      showLoading,
      clientId,
      hasExpensesInsteadOfTarget,
      goalId,
      fpId,
      isPrint,
      hasLegend,
      title,
    } = this.props;

    let Content = null;
    if (!chartData && !loading) {
      return null;
    }

    if (showLoading) {
      Content = <LoadingChart />;
    } else if (chartData) {
      Content = (
        <ReactHighcharts
          autoResize
          container={`RecommendedTargetAmountChartContainer-${fpId}-${goalId}`}
          className="RecommendedTargetAmountChartContainer"
          options={chartData}
        />
      );
    } else {
      Content = <LoadingChart />;
    }

    if (noContainer) {
      return <section className="RecommendedTargetAmountChart">{Content}</section>;
    }

    return (
      <section
        className={`RecommendedTargetAmountChart with-container${isPrint ? ' is-print' : ''}`}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Text as="h2" fontSize="h6" color="primary.500">
            {title || `${isCurrentPlan ? '' : 'Recommended '}Target Amount`}
          </Text>

          {hasLegend && (
            <ul className="legend">
              <li>
                <i />
                Expenses Covered
              </li>
              <li>
                <i className={`stripe2${isPrint ? ' is-print' : ''}`} />
                Expenses Not Covered
              </li>
            </ul>
          )}
        </Box>
        {Content}
      </section>
    );
  }
}
